import Image from 'next/image'
import { FC } from 'react'

import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { cn } from '@/app/utils'

import EmptyListPlug from './EmptyListPlug'

type Props = {
  className?: string
  isTitle?: boolean
  descriptionClassName?: string
}

const ErrorForbidden: FC<Props> = ({
  className,
  isTitle,
  descriptionClassName
}) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isDesktopScreen = [ScreenSize.Xl, ScreenSize.Xxl].includes(breakpoint)

  return (
    <div className={cn('my-[121px] max-w-[1156px]', className)}>
      <div className="flex flex-col items-center justify-center">
        <EmptyListPlug
          image={
            <Image
              src="/images/shared/forbidden.png"
              alt="image"
              width={isDesktopScreen ? '100' : '80'}
              height={isDesktopScreen ? '100' : '80'}
            />
          }
          title={
            isTitle ? (
              ''
            ) : (
              <span className="text-grey-90 text-24 lg:text-24 sm:text-20">
                В доступе отказано
              </span>
            )
          }
          description="К сожалению, у вас нет прав для просмотра"
          className="!mt-0"
          descriptionClassName={cn(
            '!text-grey-60 text-16 lg:text-16 sm:text-14',
            descriptionClassName
          )}
        />
      </div>
    </div>
  )
}

export { ErrorForbidden }
